import React from "react";
import { withRouter } from "react-router-dom";

import Config from "services/Config";
import Utils from "services/Utils";

class GoogleAnalyticsTracking extends React.Component {
    componentDidMount() {
        if (Config.APP_ENV !== "production") {
            console.log(
                "GoogleAnalyticsTracking initialized in non-production environment. Skipping Google Analytics."
            );
            return;
        }

        if (!Config.GOOGLE_ANALYTICS_ID) return;

        Utils.LoadScript(
            `https://www.googletagmanager.com/gtag/js?id=${Config.GOOGLE_ANALYTICS_ID}`
        )
            .then(() => {
                window.dataLayer = window.dataLayer || [];
                window.gtag = function () {
                    window.dataLayer.push(arguments);
                };
                window.gtag("js", new Date());
                window.gtag("config", Config.GOOGLE_ANALYTICS_ID);
            })
            .catch((e) =>
                console.error("Error loading Google Analytics script:", e)
            );
    }

    componentDidUpdate({ location, history }) {
        if (location.pathname === this.props.location.pathname) return;

        if (typeof window.gtag !== "function" || history.action !== "PUSH")
            return;

        window.gtag("config", Config.GOOGLE_ANALYTICS_ID, {
            page_title: document.title,
            page_location: window.location.href,
            page_path: location.pathname,
        });
    }

    render() {
        return null;
    }
}
export default withRouter(GoogleAnalyticsTracking);
